import { useGlobal } from '@/utils/useGlobal';

export const useUsCaConfig = (locale: string) => {
    const { useLang } = useGlobal();
    const { t } = useLang('vanliferoadtrips');

    const cards = [
        {
            // img: '',
            power: t('secH_card5_power'),
            title: t('secH_card5_title'),
            with: t('secH_card5_with'),
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/45w-portable-solar-panel?variant=41731341353033',
                    ca: 'https://ca.ecoflow.com/products/45w-portable-solar-panel?variant=52438137438579',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '7264162676809',
                    ca: '8292312449178',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '41731341353033',
                    ca: '52438137438579',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: [t('secH_card5_desc1'), t('secH_card5_desc2'), t('secH_card5_desc3')],
        },
        {
            // img: '/responsive/picture/common-products/110w.png',
            power: t('secH_card1_power'),
            title: t('secH_card1_title'),
            with: t('secH_card1_with'),
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/110w-portable-solar-panel?variant=39998109941833',
                    ca: 'https://ca.ecoflow.com/products/110w-portable-solar-panel?variant=43725961199770',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '4318647222345',
                    ca: '5511642644634',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '39998109941833',
                    ca: '43725961199770',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: [t('secH_card1_desc1'), t('secH_card1_desc2'), t('secH_card1_desc3')],
        },
        {
            // img: '/responsive/picture/common-products/160w.png',
            power: t('secH_card2_power'),
            title: t('secH_card2_title'),
            with: t('secH_card2_with'),
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/nextgen-160w-portable-solar-panel?variant=41682906218569',
                    ca: 'https://ca.ecoflow.com/products/nextgen-160w-portable-solar-panel?variant=52162328330611',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '7003543044169',
                    ca: '8066687074458',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '41682906218569',
                    ca: '52162328330611',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: [t('secH_card2_desc1'), t('secH_card2_desc2'), t('secH_card2_desc3')],
        },
        {
            // img: '/responsive/picture/common-products/220w_bifacial.png',
            power: t('secH_card3_power'),
            title: t('secH_card3_title'),
            with: t('secH_card3_with'),
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/nextgen-220w-bifacial-portable-solar-panel?variant=41670394576969',
                    ca: 'https://ca.ecoflow.com/products/220w-bifacial-portable-solar-panel?variant=43874721824922',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '7003545108553',
                    ca: '7296662896794',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '41670394576969',
                    ca: '43874721824922',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: [t('secH_card3_desc1'), t('secH_card3_desc2'), t('secH_card3_desc3')],
        },
    ];

    return {
        cards,
    };
};
